module.exports = __webpack_public_path__ + "static/img/yg_btn1.30247c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/home/pc/role3/control/yg_btn1.png
// module id = Mwb3
// module chunks = 7